'use strict';

var Sugar = require('sugar-core');

require('./build/buildDateUnitMethodsCall');

module.exports = Sugar.Date.secondsSince;


//////////////////
// WEBPACK FOOTER
// ./~/sugar/date/secondsSince.js
// module id = 589
// module chunks = 0